import React from 'react';
import { renderMarkdown } from './renderMarkdown';
import { ChatBlock } from './ChatBlock';

export function RichMessage({ segments }) {
    return (
        <div className="rich-message">
            {segments.map((segment, idx) => {
                if (segment.type === 'markdown') {
                    return (
                        <div
                            key={idx}
                            className="rich-message__markdown"
                            dangerouslySetInnerHTML={{ __html: renderMarkdown(segment.content) }}
                        />
                    );
                }

                // Block with parse error — show raw fallback
                if (segment.error) {
                    return (
                        <pre key={idx} className="rich-message__error">
                            <code>{segment.error}</code>
                        </pre>
                    );
                }

                // Valid dashbo block
                return (
                    <ChatBlock
                        key={idx}
                        blockType={segment.blockType}
                        data={segment.data}
                    />
                );
            })}
        </div>
    );
}
